// Where someone is, from their browser timezone alone (no permission prompt,
// no IP lookup). A timezone names one city per zone, so these read as
// "in Seoul" / "London time", never as a precise location.

/** This browser's IANA timezone, e.g. "Europe/London" */
export const myTimezone = (): string | undefined => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
};

/** "America/Argentina/Buenos_Aires" -> "Buenos Aires"; null for zones like "Etc/UTC" */
export const cityOf = (tz: string | undefined): string | null => {
  if (!tz || !tz.includes('/') || tz.startsWith('Etc/')) return null;
  return tz.split('/').pop()!.replace(/_/g, ' ');
};

/** Hour in that timezone, e.g. "3am", "11pm"; null if the timezone is unknown */
export const localHour = (tz: string | undefined, at: Date = new Date()): string | null => {
  if (!tz) return null;
  try {
    return new Intl.DateTimeFormat('en-US', { hour: 'numeric', hour12: true, timeZone: tz })
      .format(at)
      .replace(/\s/g, '')
      .toLowerCase();
  } catch {
    return null;
  }
};

/** "3am in Seoul"; null when the timezone gives no usable place */
export const whereLabel = (tz: string | undefined, at: Date = new Date()): string | null => {
  const city = cityOf(tz);
  const hour = localHour(tz, at);
  return city && hour ? `${hour} in ${city}` : null;
};
